import type { SearchScenarioId } from "owa-search-store";
import { action } from "satcheljs";

/**
 * This action is dispatched after the common search box starts the search session.
 * The consuming client should have an orchestrator that subscribes to it to handle
 * any scenario-specific initialization logic.
 */
export interface SEARCH_SESSION_STARTEDActionMessage {
    actionSource: string | null;
    shouldStartSearch: boolean;
    scenarioId: SearchScenarioId;
}
export const searchSessionStarted: (actionSource: string | null, shouldStartSearch: boolean, scenarioId: SearchScenarioId) => SEARCH_SESSION_STARTEDActionMessage = action("SEARCH_SESSION_STARTED", (actionSource: string | null, shouldStartSearch: boolean, scenarioId: SearchScenarioId): SEARCH_SESSION_STARTEDActionMessage => ({
    actionSource,
    shouldStartSearch,
    scenarioId,
}));
